import { createFileRoute } from '@tanstack/react-router'
import { useState } from 'react'
import { AdminShell, adminPage } from '#/components/admin/admin-shell'
import { DataTable, Pager } from '#/components/admin/ui'
import { useAdminAttribution, type AdminAttributionEvent } from '#/lib/api-admin'
import { fmtDateTime } from '#/lib/format'
import { m } from '#/paraglide/messages'

export const Route = createFileRoute('/attribution')({ component: adminPage(Page) })

function Page() {
  const [page, setPage] = useState(1)
  const { data, isLoading, isError, isFetching, refetch } = useAdminAttribution(page)
  return (
    <AdminShell title={m.admin_nav_attribution()} description={m.admin_attribution_desc()} wide>
      <DataTable<AdminAttributionEvent>
        rows={data?.events}
        loading={isLoading} error={isError} retrying={isFetching} onRetry={refetch}
        rowKey={(e) => e.id}
        cols={[
          { key: 'date', header: m.tx_col_date(), render: (e) => fmtDateTime(e.createdAt) },
          { key: 'user', header: m.admin_col_email(), render: (e) => e.userEmail ?? <span className="text-muted-foreground">{m.admin_anon()}</span> },
          { key: 'src', header: m.admin_col_source(), render: (e) => e.source ?? '—' },
          { key: 'med', header: m.admin_col_medium(), render: (e) => e.medium ?? '—' },
          { key: 'camp', header: m.admin_col_campaign(), render: (e) => e.campaign ?? '—' },
          { key: 'ref', header: m.admin_col_referrer(), render: (e) => <span className="block max-w-56 truncate text-xs">{e.referrer ?? '—'}</span> },
          { key: 'land', header: m.admin_col_landing(), render: (e) => <span className="font-mono text-xs">{e.landingPath ?? '—'}</span> },
        ]}
      />
      {data ? <Pager page={data.page} total={data.total} pageSize={data.pageSize} onPage={setPage} /> : null}
    </AdminShell>
  )
}
